import Logger from '../logger';
import { loadJSON } from '../loader';
import { getConfigOverride } from './url-config-override';

const getConfigPerURL = ({ configsURL, successCallback, errorCallback }) => {
    Logger.log('configsURL:', JSON.stringify(configsURL));
    loadJSON({
        url: configsURL,
        successCallback: (result) => {
            const pathnameWithSearch = window.location.href.replace(window.location.origin, '');
            let configFileName = '';
            for (const u in result) {
                if (pathnameWithSearch.match(new RegExp(u))) {
                    configFileName = result[u];
                    break;
                }
            }

            Logger.log('configFileName:', configFileName);
            if (!configFileName) {
                successCallback(null);
            } else {
                loadJSON({
                    url: window.WC.config.env.baseURL + '/url-configs/' + configFileName,
                    successCallback: (result) => {
                        successCallback(result);
                    },
                    errorCallback: errorCallback
                });
            }
        },
        errorCallback: errorCallback
    });
};

const processConfigPerURL = (config, launchConfigCallback) => {
    Logger.log('config content:', JSON.stringify(config));
    launchConfigCallback(config);
};

const initConfigPerURL = ({ launchConfigCallback }) => {
    const config = getConfigOverride();
    if (config) {
        launchConfigCallback(config);
    } else {
        getConfigPerURL({
            configsURL: window.WC.config.env.baseURL + '/url-configs.json',
            successCallback: (result) => {
                processConfigPerURL(result, launchConfigCallback);
            },
            errorCallback: (error) => {
                console.error(`WC BASE: error loading config per URL: ${error}`);
            }
        });
    }
};

export { initConfigPerURL };
